export enum NoteEntityType {
  Webmasters = 'webmasters',
  Promos = 'promos',
  Offers = 'offers',
  Streams = 'streams',
  WithdrawalRequests = 'withdrawal_requests',
  Advertisers = 'advertisers',
  AdvertiserEntities = 'advertiser_entities',
  BillDocuments = 'bill_documents',
  ContractDocuments = 'contract_documents',
  VerificationDocuments = 'verification_documents',
}
